export const recipeSubTitleAvailabilityMap = {
  agnostic: true,
};
